import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import EmailLinkForm from '../components/EmailLinkForm'
import UnsupportedBrowser from '../components/UnsupportedBrowser'
import { getBrowser } from '../lib/browser'

interface LoginProps {
  emailAutosentTo: string
}

export default function Login({ emailAutosentTo }: LoginProps) {
  const theme = useTheme()
  const browser = getBrowser()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.grey[100],
      }}
    >
      <Card
        sx={{
          minHeight: '310px',
          maxWidth: '400px',
          width: '100%',
          position: 'relative',
          border: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ p: 3 }}>
          {!browser.supported ? (
            <UnsupportedBrowser browser={browser} />
          ) : (
            <EmailLinkForm isOpen={true} emailAutosentTo={emailAutosentTo} />
          )}
        </Box>
      </Card>
    </Box>
  )
}
